import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml, SafeStyle, SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import DOMPurify from 'dompurify';
import { DOMPURIFY_RICH_CONFIG } from './ParsesafeHtml.pipe';

@Pipe({
  name: "safe"
})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeUrl | SafeResourceUrl {
    switch (type) {
      case "html":
        // Sanitize with DOMPurify before bypassing Angular's XSS protection. (CR-4, R1 H-10)
        return this.sanitizer.bypassSecurityTrustHtml(
          DOMPurify.sanitize(value, DOMPURIFY_RICH_CONFIG) as string
        );
      case "style":
        return this.sanitizer.bypassSecurityTrustStyle(value);
      // 'script' case intentionally removed — bypassSecurityTrustScript is never safe to use. (R2-10)
      case "url":
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case "resourceUrl":
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
